import { z } from 'zod';
import { BodySlotSchema, ItemInstanceSchema } from '../data/items.js';
import { LookSchema } from '../data/look.js';
/**
 * Inspecting another player (ADR 0085): what they wear, piece by piece, as
 * the chat's item links show it (+N, affixes). Asked by name from the menu a
 * click on them opens; the server answers the asker alone, and only about a
 * player of the same zone, the one they could click. Never the bag, the gold
 * or the career: only what everyone already sees on the body, in detail.
 */
export const InspectRequestSchema = z.object({ name: z.string().trim().min(1).max(32) }).strict();
export const InspectionSchema = z.object({
    name: z.string().min(1),
    classId: z.string().min(1),
    level: z.number().int().min(1),
    look: LookSchema,
    /** Every place worn, cosmetics and companions included, as their instances. */
    equipped: z.partialRecord(BodySlotSchema, ItemInstanceSchema),
});
/** `not-found`: nobody of that name in the zone, or someone who blocked the asker (ADR 0076). */
export const InspectRejectedSchema = z.object({ reason: z.enum(['invalid', 'not-found']) });
//# sourceMappingURL=inspect.js.map